<template>
	<v-card v-if="posts && posts.length > 0" flat outlined class="wall-card">
		<v-card-title class="d-flex justify-content-between">
			<div>Wpisy</div>
			<div class="d-flex">
				<div class="d-flex align-center">
					<div class="mr-2 grey--text text--darken-2 font-14 font-weight-medium">Sortuj:</div>
					<little-select
						:value="sortBy"
						@selected="filterSelected"
					/>
				</div>
			</div>
		</v-card-title>
		<v-card-text>
			<post
				v-for="post in posts"
				:post="post"
				simple
				:key="'searcher-post-' + post.id"
			/>
		</v-card-text>
	</v-card>
</template>

<script>
import Post from "@/components/wall/post/Post";
import {mapActions, mapGetters} from "vuex";
import LittleSelect from "@/components/items/LittleSelect";
export default {
	name: "SearchResultsPosts",
	components: {
		Post,
		LittleSelect
	},
	data() {
		return {
			sortBy: 'new'
		}
	},
	computed: {
		...mapGetters({
			posts: "searcher/posts",
			phrase: "searcher/phrase",
		}),
	},
	watch: {
		posts: {
			handler(v) {
				this.$emit('input', v)
			},
			deep: true
		}
	},
	methods: {
		...mapActions('searcher', [
			'mainSearchPosts'
		]),
		filterSelected(v) {
			this.sortBy = v
			this.filter()
		},
		filter() {
			let params = {
				sort_by: this.sortBy,
				content: this.phrase
			}
			this.mainSearchPosts({ params })
		}
	}
}
</script>

<style scoped>

</style>
